function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47 11.655c-4-2.655-9.855-3.568-14.179.424-1 .923-3.802 3.82-4.43 5C22.525 24.251 21.278 26.09 13 31c-3 2-4.75 3.759-5.75 4.681C2.905 39.691 3 46 5.737 49.826 10 53 15.614 53.46 19.96 49.45c1-.923 3.041-2.45 5.041-5.45 4.82-5.952 10.703-10.885 15.191-14.135 1.228-.532 4.34-3.095 5.339-4.017C49.875 21.837 49 17 47.043 11.701l-.042-.046z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.293 13.366c-8.624 2.496-10.448 10.157-15.867 14.645-6.496 5.38-13.486 8.805-16.588 15.311M44.566 16.911c-4.71 8.71-10.96 9.603-15.867 14.645-5.883 6.045-9.497 13.127-16.588 15.311M33.199 14.462c5.041 2.539 8.02 6.363 9.985 10.818M27.04 21.603c4.354 2.193 6.926 5.495 8.624 9.343M11.586 34.411c2.128 5.228 5.702 8.502 9.985 10.818M19.196 28.843c1.838 4.515 4.924 7.343 8.624 9.343"
}));

var SvgPeanut = function SvgPeanut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPeanut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Peanut.d0ed9031.svg";
export { ForwardRef as ReactComponent };